export default __webpack_public_path__ + "static/media/mh.dd7c5e18.svg";